/**
 * @generated SignedSource<<e2fcf0ff4d78cd19dc93b7df47e36e0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pantoneLibraryColorsContainerQuery$variables = {
  after?: string | null;
  first?: number | null;
  id?: string | null;
  onlyDefaultColors?: boolean | null;
  orderBy?: string | null;
  paletteTypeID?: number | null;
  search?: string | null;
  useConversionTable?: boolean | null;
};
export type pantoneLibraryColorsContainerQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pantoneLibraryColorsContainer_colors">;
};
export type pantoneLibraryColorsContainerQuery = {
  response: pantoneLibraryColorsContainerQuery$data;
  variables: pantoneLibraryColorsContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": "1",
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 70,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "onlyDefaultColors"
  },
  {
    "defaultValue": "DESC",
    "kind": "LocalArgument",
    "name": "orderBy"
  },
  {
    "defaultValue": 1,
    "kind": "LocalArgument",
    "name": "paletteTypeID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "useConversionTable"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "onlyDefaultColors",
    "variableName": "onlyDefaultColors"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "paletteTypeID",
    "variableName": "paletteTypeID"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "useConversionTable",
    "variableName": "useConversionTable"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pantoneLibraryColorsContainerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "pantoneLibraryColorsContainer_colors"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pantoneLibraryColorsContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PaletteColorsConnection",
        "kind": "LinkedField",
        "name": "paletteColors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaletteColorsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaletteColor",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "colorID",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rgbHexCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cmykHexCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spotColorName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "search",
          "id",
          "paletteTypeID",
          "onlyDefaultColors",
          "orderBy",
          "useConversionTable"
        ],
        "handle": "connection",
        "key": "pantoneLibraryColorsContainerColorsQuery_paletteColors",
        "kind": "LinkedHandle",
        "name": "paletteColors"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PalettesWithColorsConnection",
        "kind": "LinkedField",
        "name": "palettesWithColors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PalettesWithColorsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Palette",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useConversionTable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paletteTypeID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isZakekeDefault",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e4e602c349352e3cd3019b606d5919f9",
    "id": null,
    "metadata": {},
    "name": "pantoneLibraryColorsContainerQuery",
    "operationKind": "query",
    "text": "query pantoneLibraryColorsContainerQuery(\n  $after: String = \"1\"\n  $first: Int = 70\n  $id: String = null\n  $onlyDefaultColors: Boolean = null\n  $orderBy: String = \"DESC\"\n  $paletteTypeID: Int = 1\n  $search: String = null\n  $useConversionTable: Boolean = null\n) {\n  ...pantoneLibraryColorsContainer_colors_3e1OQA\n}\n\nfragment pantoneLibraryColorsContainer_colors_3e1OQA on Query {\n  paletteColors(first: $first, after: $after, search: $search, id: $id, paletteTypeID: $paletteTypeID, onlyDefaultColors: $onlyDefaultColors, orderBy: $orderBy, useConversionTable: $useConversionTable) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        colorID\n        name\n        rgbHexCode\n        cmykHexCode\n        spotColorName\n        __typename\n      }\n    }\n  }\n  palettesWithColors {\n    edges {\n      node {\n        id\n        name\n        useConversionTable\n        paletteTypeID\n        isZakekeDefault\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9f9fa87357b617f8b77c09c6f512a5b";

export default node;
